import { FormattedMessage } from "react-intl";

const AlertIntegrationIncidentInvestigation = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.alertIntegrationIncidentInvestigation.content.body"
                    defaultMessage="Take advantage of alerts, incident data, service and infrastructure health analysis to detect and resolve incidents faster."
                />
            </p>
        </div>
    );
};

export default AlertIntegrationIncidentInvestigation;
